import { combineEpics } from 'redux-observable'
import ArtworkEpics from 'epics/artworkEpics'
import ClipboardEpics from 'epics/utility/clipboard'
import AlgoliaEpics from './algolia'
import AppEpics from './app'

const epicList = [...AlgoliaEpics, ...AppEpics, ...ClipboardEpics]

export default combineEpics(...ArtworkEpics, ...epicList)
